//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    catalogView_GetCadenasDataByUrl(cadenasIdentifier?: string | null | undefined): Observable<CadenasDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/CadenasData?";
        if (cadenasIdentifier !== undefined && cadenasIdentifier !== null)
            url_ += "cadenasUrl=" + encodeURIComponent("" + cadenasIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCadenasDataByUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCadenasDataByUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CadenasDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CadenasDto>;
        }));
    }

    protected processCatalogView_GetCadenasDataByUrl(response: HttpResponseBase): Observable<CadenasDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CadenasDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetDgnbSustainabilityInfo(catalogItemGuid?: string | undefined): Observable<DgnbDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/DGNBSustainabilityInfo?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetDgnbSustainabilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetDgnbSustainabilityInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DgnbDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DgnbDto>;
        }));
    }

    protected processCatalogView_GetDgnbSustainabilityInfo(response: HttpResponseBase): Observable<DgnbDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DgnbDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetSentinelData(catalogItemGuid?: string | undefined, ean?: string | null | undefined): Observable<SentinelDocumentItem[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/SentinelSustainabilityDocuments?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        if (ean !== undefined && ean !== null)
            url_ += "ean=" + encodeURIComponent("" + ean) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetSentinelData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetSentinelData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SentinelDocumentItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SentinelDocumentItem[]>;
        }));
    }

    protected processCatalogView_GetSentinelData(response: HttpResponseBase): Observable<SentinelDocumentItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SentinelDocumentItem[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetSentinelSustainabilityInfo(catalogItemGuid?: string | undefined): Observable<SentinelDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/SentinelSustainabilityInfo?";
        if (catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' cannot be null.");
        else if (catalogItemGuid !== undefined)
            url_ += "catalogItemGuid=" + encodeURIComponent("" + catalogItemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetSentinelSustainabilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetSentinelSustainabilityInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SentinelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SentinelDto>;
        }));
    }

    protected processCatalogView_GetSentinelSustainabilityInfo(response: HttpResponseBase): Observable<SentinelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SentinelDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetAutodeskViewerSource(attachmentId: number): Observable<AutodeskViewerDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/autodeskViewer/attachmentId/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetAutodeskViewerSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetAutodeskViewerSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutodeskViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutodeskViewerDto>;
        }));
    }

    protected processCatalogView_GetAutodeskViewerSource(response: HttpResponseBase): Observable<AutodeskViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutodeskViewerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetBimObjectViewerSource(gtin: string, language: CatalogLanguage): Observable<BimObjectEmbedData> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/bimObjectViewer/gtin/{gtin}/language/{language}";
        if (gtin === undefined || gtin === null)
            throw new globalThis.Error("The parameter 'gtin' must be defined.");
        url_ = url_.replace("{gtin}", encodeURIComponent("" + gtin));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetBimObjectViewerSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetBimObjectViewerSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BimObjectEmbedData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BimObjectEmbedData>;
        }));
    }

    protected processCatalogView_GetBimObjectViewerSource(response: HttpResponseBase): Observable<BimObjectEmbedData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BimObjectEmbedData;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogContactsByCatalogKey(catalogKey: string): Observable<CatalogViewContactListDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogContact/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogContactsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogContactsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewContactListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewContactListDto>;
        }));
    }

    protected processCatalogView_GetCatalogContactsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewContactListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewContactListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogItemMetaDataByGuid(catalogGuid: string): Observable<CatalogItemMetaDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogItem/{catalogGuid}/meta";
        if (catalogGuid === undefined || catalogGuid === null)
            throw new globalThis.Error("The parameter 'catalogGuid' must be defined.");
        url_ = url_.replace("{catalogGuid}", encodeURIComponent("" + catalogGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogItemMetaDataByGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogItemMetaDataByGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemMetaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemMetaDto>;
        }));
    }

    protected processCatalogView_GetCatalogItemMetaDataByGuid(response: HttpResponseBase): Observable<CatalogItemMetaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemMetaDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogItemDetailsByCatalogItemGuid(catalogItemGuid: string): Observable<CatalogItemDetailsDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogItemGuid/{catalogItemGuid}/details";
        if (catalogItemGuid === undefined || catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' must be defined.");
        url_ = url_.replace("{catalogItemGuid}", encodeURIComponent("" + catalogItemGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemDetailsDto>;
        }));
    }

    protected processCatalogView_GetCatalogItemDetailsByCatalogItemGuid(response: HttpResponseBase): Observable<CatalogItemDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogInformationByCatalogKey(catalogKey: string): Observable<CatalogViewCatalogInformationDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogInformationByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogInformationByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewCatalogInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewCatalogInformationDto>;
        }));
    }

    protected processCatalogView_GetCatalogInformationByCatalogKey(response: HttpResponseBase): Observable<CatalogViewCatalogInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewCatalogInformationDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogAboutUsCategoryInfoByCatalogKey(catalogKey: string, category: CatalogAboutUsCategory): Observable<CatalogViewAboutUsDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/category/{categoryId}";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        if (category === undefined || category === null)
            throw new globalThis.Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + category));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogAboutUsCategoryInfoByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogAboutUsCategoryInfoByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewAboutUsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewAboutUsDto>;
        }));
    }

    protected processCatalogView_GetCatalogAboutUsCategoryInfoByCatalogKey(response: HttpResponseBase): Observable<CatalogViewAboutUsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewAboutUsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetForeignLanguageCatalogsByCatalogKey(catalogKey: string): Observable<CatalogViewForeignLanguageCatalogsDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/foreignLanguages";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewForeignLanguageCatalogsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewForeignLanguageCatalogsDto[]>;
        }));
    }

    protected processCatalogView_GetForeignLanguageCatalogsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewForeignLanguageCatalogsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewForeignLanguageCatalogsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogMetaByCatalogKey(catalogKey: string): Observable<CatalogViewGroupDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/meta";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogMetaByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogMetaByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewGroupDto>;
        }));
    }

    protected processCatalogView_GetCatalogMetaByCatalogKey(response: HttpResponseBase): Observable<CatalogViewGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewGroupDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetNewsForCatalogView(catalogKey: string): Observable<CatalogViewNewsShortDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/newsCatalogView";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetNewsForCatalogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetNewsForCatalogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewNewsShortDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewNewsShortDto[]>;
        }));
    }

    protected processCatalogView_GetNewsForCatalogView(response: HttpResponseBase): Observable<CatalogViewNewsShortDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewNewsShortDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetNewsForDialog(catalogKey: string): Observable<CatalogViewNewsListDto> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/newsDialog";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetNewsForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetNewsForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewNewsListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewNewsListDto>;
        }));
    }

    protected processCatalogView_GetNewsForDialog(response: HttpResponseBase): Observable<CatalogViewNewsListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewNewsListDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetRelatedCatalogsByCatalogKey(catalogKey: string): Observable<CatalogViewRelatedCatalogsDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/related";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetRelatedCatalogsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetRelatedCatalogsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewRelatedCatalogsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewRelatedCatalogsDto[]>;
        }));
    }

    protected processCatalogView_GetRelatedCatalogsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewRelatedCatalogsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewRelatedCatalogsDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetAttachmentTagsByCatalogKey(catalogKey: string): Observable<CatalogViewTagDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKey/{catalogKey}/tags";
        if (catalogKey === undefined || catalogKey === null)
            throw new globalThis.Error("The parameter 'catalogKey' must be defined.");
        url_ = url_.replace("{catalogKey}", encodeURIComponent("" + catalogKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetAttachmentTagsByCatalogKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetAttachmentTagsByCatalogKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewTagDto[]>;
        }));
    }

    protected processCatalogView_GetAttachmentTagsByCatalogKey(response: HttpResponseBase): Observable<CatalogViewTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewTagDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogKeyForCatalogItemGuid(catalogItemGuid: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/catalogKeyByCatalogItemGuid/{catalogItemGuid}";
        if (catalogItemGuid === undefined || catalogItemGuid === null)
            throw new globalThis.Error("The parameter 'catalogItemGuid' must be defined.");
        url_ = url_.replace("{catalogItemGuid}", encodeURIComponent("" + catalogItemGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogKeyForCatalogItemGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogKeyForCatalogItemGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCatalogView_GetCatalogKeyForCatalogItemGuid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetFolderView(catalogGuids: string[]): Observable<CatalogItemFolderViewDto[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/folderViewItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogGuids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetFolderView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetFolderView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogItemFolderViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogItemFolderViewDto[]>;
        }));
    }

    protected processCatalogView_GetFolderView(response: HttpResponseBase): Observable<CatalogItemFolderViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogItemFolderViewDto[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    catalogView_GetCatalogViewTreeItemTypes(): Observable<CatalogViewTreeItemType[]> {
        let url_ = this.baseUrl + "/api/v3/CatalogView/itemTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCatalogView_GetCatalogViewTreeItemTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogView_GetCatalogViewTreeItemTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogViewTreeItemType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogViewTreeItemType[]>;
        }));
    }

    protected processCatalogView_GetCatalogViewTreeItemTypes(response: HttpResponseBase): Observable<CatalogViewTreeItemType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CatalogViewTreeItemType[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface AboutUsDtoBase {
}

export interface AdditionalInfoDto {
    title?: string | undefined;
    text?: string | undefined;
    showTitleAsString: boolean;
    isPrice: boolean;
}

export enum AttachmentTypeEnum {
    Unknown = 0,
    Link = 10,
    Images = 200,
    Videos = 300,
    Documents = 400,
    Bim = 600,
    Error = -1,
}

export enum AttachmentTypeId {
    Error = 1,
    Unknown = 2,
    Link = 10,
    Jpg = 101,
    Jpeg = 102,
    Jpe = 103,
    Gif = 104,
    Png = 105,
    Tiff = 106,
    Tif = 107,
    Bmp = 108,
    Svg = 109,
    Mpeg = 200,
    Mpg = 201,
    Mpe = 202,
    Mp4 = 203,
    Qt = 204,
    Mov = 205,
    Webm = 208,
    Avi = 209,
    Movie = 210,
    Csv = 300,
    Txt = 301,
    Rtx = 302,
    Rtf = 303,
    Xls = 304,
    Xla = 305,
    Xlsx = 306,
    Doc = 307,
    Dot = 308,
    Docx = 309,
    Ppt = 310,
    Ppz = 311,
    Pps = 312,
    Pot = 313,
    Pptx = 314,
    Pdf = 315,
    Ai = 316,
    Eps = 317,
    Ps = 318,
    Xml = 319,
    Ifc = 501,
    Dxf = 502,
    Dwg = 503,
    Dwf = 504,
    Rvt = 505,
    Rfa = 506,
    Pln = 507,
    Sldprt = 508,
    Igs = 509,
    Step = 510,
    Ldt = 511,
    Edz = 512,
    Lcf = 513,
    Wspak = 514,
    Stp = 515,
    Bimobject = 1001,
    Cadenas = 1002,
    Cadclick = 1003,
    Dgnb = 1004,
    Sentinel = 1005,
    Zip = 10001,
    D81 = 10002,
}

export interface AutodeskViewerDto {
    token?: string | undefined;
    resourceIdentifier?: string | undefined;
    conversionFailed: boolean;
}

export interface BimObjectDto {
    gtin?: string | undefined;
}

export interface BimObjectEmbedData {
    iframeUrl?: string | undefined;
    files?: BimObjectEmbedDataFile[] | undefined;
}

export interface BimObjectEmbedDataFile {
    downloadUrl?: string | undefined;
    name?: string | undefined;
    fileTypeName?: string | undefined;
}

export interface CadClickDto {
    path?: string | undefined;
}

export interface CadenasDto {
    mIdentPath?: string | undefined;
    apiKey?: string | undefined;
    baseUrl?: string | undefined;
    userServerType?: string | undefined;
    path?: string | undefined;
    configuration?: string | undefined;
    catalog?: string | undefined;
    part?: string | undefined;
}

export enum CatalogAboutUsCategory {
    None = 0,
    AboutUs = 1,
    Sustainability = 2,
    References = 4,
    ServiceAdviceTools = 8,
}

export enum CatalogAboutUsSubCategory {
    Unknown = 0,
    Description = 1,
    ImagesAndDocuments = 2,
    Links = 3,
    AdditionalContacts = 4,
}

export interface CatalogAdditionalContactDto extends AboutUsDtoBase {
    id: number;
    catalogId: number;
    catalogAboutUsCategory: CatalogAboutUsCategory;
    sector: string;
    email: string;
    phoneNumber?: string | undefined;
    telefax?: string | undefined;
}

export interface CatalogAttachmentDto {
    id: number;
    title?: string | undefined;
    fileName?: string | undefined;
    url?: string | undefined;
    catalogId: number;
    teaserText?: string | undefined;
    attachmentTypeId: AttachmentTypeId;
    type?: AttachmentTypeEnum | undefined;
    viewer?: Viewer | undefined;
    extension?: string | undefined;
    fileSize?: string | undefined;
    viewerUri?: string | undefined;
    catalogAboutUsCategory: CatalogAboutUsCategory;
    catalogAboutUsSubCategory: CatalogAboutUsSubCategory;
    created: Date;
    updated?: Date | undefined;
}

export interface CatalogCompanyDescriptionDto extends AboutUsDtoBase {
    id: number;
    catalogId: number;
    catalogAboutUsCategory: CatalogAboutUsCategory;
    description?: string | undefined;
}

export interface CatalogItemDetailsDto {
    catalogId: number;
    catalogItemId: number;
    catalogKey?: string | undefined;
    type: CatalogItemType;
    tags?: TagType[] | undefined;
    viewGroups?: ViewGroupDto[] | undefined;
}

export interface CatalogItemFolderViewDto {
    id: number;
    title?: string | undefined;
    guid: string;
    description?: string | undefined;
    logo?: string | undefined;
}

export interface CatalogItemMetaDto {
    title?: string | undefined;
    description?: string | undefined;
    guid: string;
}

export enum CatalogItemType {
    Position = 0,
    TextPosition = 400,
    Document = 1200,
    Root = 2000,
    Folder = 3000,
    Unknown = -1,
}

export enum CatalogLanguage {
    German = 0,
    English = 1,
    Italian = 2,
    French = 3,
    Spanish = 4,
    Dutch = 5,
    Danish = 6,
    Swedish = 7,
    Lithuanian = 8,
    Norwegian = 9,
    Estonian = 10,
    Latvian = 11,
    Polish = 12,
    Turkish = 13,
}

export enum CatalogNewsCategoryType {
    News = 0,
    NewProduct = 1,
    DateAndEvents = 2,
    Sustainability = 3,
}

export enum CatalogStateEnum {
    New = 0,
    Preview = 100,
    Published = 200,
    PendingPublish = 300,
}

export interface CatalogViewAboutUsDto {
    catalogKey: string;
    category: CatalogAboutUsCategory;
    companyDescription?: CatalogCompanyDescriptionDto | undefined;
    catalogAttachmentGroups?: { [key in keyof typeof CatalogAboutUsSubCategory]?: CatalogAttachmentDto[]; } | undefined;
    catalogAdditionalContacts?: CatalogAdditionalContactDto[] | undefined;
}

export interface CatalogViewCatalogInformationDto {
    id: number;
    key?: string | undefined;
    catalogState: CatalogStateEnum;
    title?: string | undefined;
    description?: string | undefined;
    catalogMetaDescription?: string | undefined;
    language: CatalogLanguage;
    categoryResourceKeys?: { [key: string]: string[]; } | undefined;
    categoryGroupIds?: number[] | undefined;
    featureToggles?: FeatureToggleValuesDto | undefined;
    watchListVersion?: string | undefined;
    exportSettings?: ExportSettingsDto | undefined;
    hasAboutUs: boolean;
    hasSustainability: boolean;
    hasReferences: boolean;
    hasService: boolean;
    hasContactPersons: boolean;
    hasNews: boolean;
    catalogViewShowPrice: DisplaySetting;
    catalogViewShowsProductNumber: boolean;
    catalogViewShowsGtin: boolean;
}

export interface CatalogViewContactDto {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    sector?: string | undefined;
    region?: string | undefined;
    email?: string | undefined;
    phoneOne?: string | undefined;
    phoneTwo?: string | undefined;
    contactPicture?: string | undefined;
}

export interface CatalogViewContactListDto {
    catalogViewContact?: CatalogViewContactDto[] | undefined;
}

export interface CatalogViewForeignLanguageCatalogsDto {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
    languageAssetName?: string | undefined;
    categoryTitleResourceKeys?: string[] | undefined;
}

export interface CatalogViewGroupDto {
    id: number;
    manufacturerName?: string | undefined;
    catalogDescription?: string | undefined;
    streetAndNumber?: string | undefined;
    countryZipAndCity?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email1?: string | undefined;
    email2?: string | undefined;
    webSite1?: string | undefined;
    webSite2?: string | undefined;
    countTexts: number;
    countImagesAndVideos: number;
    countDocuments: number;
    countCadAndBim: number;
    countLinks: number;
    socialMedia?: SocialMediaDto[] | undefined;
    lastUpdate: Date;
    categoriesResourceKeys?: CategoryResource[] | undefined;
    featureToggles?: FeatureToggleValuesDto | undefined;
}

export interface CatalogViewNewsDto {
    id: number;
    imageUrl?: string | undefined;
    teaser?: string | undefined;
    title?: string | undefined;
    text?: string | undefined;
    startDate?: Date | undefined;
    endDate: Date;
    categoryType: CatalogNewsCategoryType;
    keywords?: string[] | undefined;
    catalogItemGuid?: string | undefined;
    additionalInformationsUrl?: string | undefined;
    videoUrl?: string | undefined;
    type: NewsType;
}

export interface CatalogViewNewsListDto {
    catalogViewNews?: CatalogViewNewsDto[] | undefined;
    webSite?: string | undefined;
}

export interface CatalogViewNewsShortDto {
    id: number;
    imageUrl?: string | undefined;
    title?: string | undefined;
}

export interface CatalogViewRelatedCatalogsDto {
    id: number;
    key?: string | undefined;
    title?: string | undefined;
    categoryTitleResourceKeys?: string[] | undefined;
}

export interface CatalogViewTagDto {
    id: number;
    titleResourceKey?: string | undefined;
}

export enum CatalogViewTreeItemType {
    Unknown = 0,
    Folder = 1,
    FolderWithAttachments = 2,
    TextOrDocument = 3,
    TextOrDocumentWithAttachments = 4,
    Position = 5,
    PositionWithAttachments = 6,
}

export interface CategoryResource {
    categoryGroupResourceKey?: string | undefined;
    categoryResourceKey?: string | undefined;
}

export interface DgnbCertificateItem {
    name?: string | undefined;
    imageUrl?: string | undefined;
}

export interface DgnbDocumentItem {
    filename?: string | undefined;
    shortName?: string | undefined;
    documentUrl?: string | undefined;
    attachmentId: number;
}

export interface DgnbDto {
    product?: string | undefined;
    manufacturer?: string | undefined;
    dgnbGlobalWarmingPotentialItems?: DgnbGlobalWarmingPotentialItem[] | undefined;
    dgnbDocumentItems?: DgnbDocumentItem[] | undefined;
    dgnbCertificateItems?: DgnbCertificateItem[] | undefined;
    dgnbMkmVersionsItems?: DgnbMkmVersionsItem[] | undefined;
}

export interface DgnbGlobalWarmingPotentialItem {
    question?: string | undefined;
    answer?: string | undefined;
    unit?: string | undefined;
}

export interface DgnbMkmVersionsItem {
    name?: string | undefined;
    qualityPhase?: string | undefined;
}

export enum DisplaySetting {
    Visible = 0,
    VisibleForRegisteredUsers = 1,
    Hidden = 2,
}

export enum ExportLimit {
    Limited = 0,
    Unlimited = 1,
}

export interface ExportSettingsDto {
    maxEverybodyPositions: number;
    maxRegisteredUsersPositions: number;
    minPositionsForWarning: number;
    exportLimit: ExportLimit;
}

export enum FeatureToggleName {
    FeatureTogglesUseLicenseServer = 0,
    CatalogAdminIntegration = 1,
    CatalogAdminAdvertising = 2,
    CatalogAdminAnalyticsContacts = 3,
    CatalogAdminAnalyticsViewsInternalAdvertising = 4,
    LicenseCatalogCount = 5,
    LicenseKeywordCount = 6,
    LicenseCatalogItemsPerCatalog = 7,
    LicensePublishCatalog = 8,
    LicenseAnalyticsBasic = 9,
    LicenseAnalyticsAdvanced = 10,
    LicenseAnalyticsExperts = 11,
    LicenseAnalyticsIntegrationStatusCount = 12,
    LicenseAdditionalCategories = 13,
    LicenseCatalogManager = 14,
    WatchList = 15,
    CatalogNews = 16,
    IntegrationApi10SilentExport = 17,
    IntegrationV2IntegrationKeysMax = 18,
    LogoAds = 19,
    UseKeywordsApiForSearchKeywords = 20,
    UseKeywordsApiGlobalForData = 21,
}

export interface FeatureToggleValuesDtoOfFeatureToggleName {
    simpleFeatureToggles?: { [key in keyof typeof FeatureToggleName]?: boolean; } | undefined;
    numericFeatureToggles?: { [key in keyof typeof FeatureToggleName]?: number; } | undefined;
}

export interface FeatureToggleValuesDto extends FeatureToggleValuesDtoOfFeatureToggleName {
}

export interface KeyValuePairOfIntegerAndString {
    key: number;
    value?: string | undefined;
}

export interface LinkDto {
    linkUrl?: string | undefined;
    id: number;
    title?: string | undefined;
}

export enum Metadata {
    None = 0,
    AttachmentName = 1,
    Extension = 2,
    FileName = 4,
    FileSizeFormat = 5,
    Tags = 6,
    FileSize = 7,
    Duration = 8,
    Pages = 9,
    Description = 10,
    UploadDate = 11,
}

export interface MetadataDto {
    key: Metadata;
    value?: string | undefined;
    tags?: KeyValuePairOfIntegerAndString[] | undefined;
}

export enum NewsType {
    TextAndImage = 0,
    Video = 1,
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface SentinelDocumentItem {
    title?: string | undefined;
    shortName?: string | undefined;
    originalFilename?: string | undefined;
    documentUrl?: string | undefined;
    attachmentId: number;
}

export interface SentinelDto {
    product?: string | undefined;
    manufacturer?: string | undefined;
    sentinelQualityLevelItems?: SentinelQualityLevelItem[] | undefined;
    sentinelDocumentItems?: SentinelDocumentItem[] | undefined;
}

export interface SentinelQualityLevelItem {
    name?: string | undefined;
}

export interface SocialMediaDto {
    socialMediaType: SocialMediaType;
    domain?: string | undefined;
    allowedDomainNames?: string[] | undefined;
}

export enum SocialMediaType {
    Unknown = 0,
    Xing = 1,
    Facebook = 2,
    Twitter = 3,
    Instagram = 4,
    LinkedIn = 5,
    YouTube = 6,
    Pinterest = 7,
}

export enum TagType {
    Unknown = 0,
    Image = 1,
    Video = 2,
    Document = 3,
    CadBim = 4,
    DataSheet = 11,
    Instruction = 12,
    Certificate = 13,
    PdfDrawing = 14,
    Sustainability = 15,
    CadFormat = 21,
    Ifc = 22,
    Price = 31,
    ProductNumber = 41,
    Din276 = 51,
    WorkCategory = 52,
    BimObject = 61,
    Cadenas = 62,
    CadClick = 63,
    Dgnb = 64,
    Sentinel = 65,
}

export enum ViewGroup {
    Unknown = 0,
    Protocol = 50,
    CatalogInfo = 80,
    CatalogContact = 81,
    CatalogRelations = 82,
    CatalogContactPersons = 83,
    AboutUs = 90,
    AboutUsSustainability = 91,
    AboutUsReferences = 92,
    AboutUsService = 93,
    Overview = 100,
    OverviewFolder = 150,
    WatchlistFolder = 170,
    WatchlistUserdefinedFolder = 180,
    ImageAndVideo = 200,
    Images = 210,
    Videos = 220,
    Documents = 300,
    CadAndBim = 400,
    LinkAndComment = 500,
    Links = 510,
    Comments = 520,
    Sustainability = 900,
    Error = 1000,
}

export interface ViewGroupDto {
    viewGroup: ViewGroup;
    hasThumbnails: boolean;
    viewGroupItems?: ViewGroupItemDto[] | undefined;
}

export interface ViewGroupItemDto {
    attachmentType: AttachmentTypeEnum;
    viewer: Viewer;
    viewGroup: ViewGroup;
    id?: number | undefined;
    title?: string | undefined;
    displayUrl?: string | undefined;
    thumbnailUrl?: string | undefined;
    defaultImageUrl?: string | undefined;
    catalogItemId: number;
    text?: string | undefined;
    comment?: string | undefined;
    extension?: string | undefined;
    additionalInfos?: AdditionalInfoDto[] | undefined;
    links?: LinkDto[] | undefined;
    hasMetadata: boolean;
    metadataList?: MetadataDto[] | undefined;
    isPreview: boolean;
    isDownloadLoginRequired: boolean;
    dgnbSustainability?: DgnbDto | undefined;
    sentinelSustainability?: SentinelDto | undefined;
    cadClick?: CadClickDto | undefined;
    bimObject?: BimObjectDto | undefined;
    catalogViewTreeItemType?: CatalogViewTreeItemType | undefined;
}

export enum Viewer {
    Unknown = 0,
    CatalogInfoViewer = 110,
    CatalogContactViewer = 111,
    CatalogRelationsViewer = 112,
    CatalogContactPersonViewer = 113,
    AboutUsAboutUsViewer = 120,
    AboutUsSustainabilityViewer = 121,
    AboutUsReferencesViewer = 122,
    AboutUsServiceViewer = 123,
    ProtocolViewer = 200,
    WatchlistRoot = 300,
    WatchlistUserdefinedRoot = 320,
    WatchlistUserdefinedFolder = 321,
    FolderContentViewer = 500,
    FileViewer = 800,
    LinkViewer = 801,
    ImageViewer = 802,
    TextViewer = 803,
    PdfViewer = 805,
    HtmlViewer = 808,
    FileVideoViewer = 809,
    YoutubeVideoViewer = 810,
    VimeoVideoViewer = 811,
    AutodeskViewer = 850,
    BimObjectViewer = 851,
    CadenasViewer = 852,
    CadClickViewer = 853,
    SustainabilityViewer = 900,
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}